export const TOGGLE_EDIT_VENDOR_PRICING_AGREEMENT_MODAL =
  'TOGGLE_EDIT_VENDOR_PRICING_AGREEMENT_MODAL'

export const toggleEditVendorPricingAgreementModal = (show: boolean) => ({
  type: TOGGLE_EDIT_VENDOR_PRICING_AGREEMENT_MODAL,
  show,
})
